import { Trans, useTranslation } from 'react-i18next';
import Link from 'Components/shared/Link/Link';
import dynamic from 'next/dynamic';
import { PATHS } from '../../../../libraries/routes.library';
import styles from './GameBlock.module.scss';

const Background = dynamic(() => import('./elements/Background/Background'), { ssr: false });

const GameBlock = () => {
  const { t } = useTranslation();

  return (
    <div className={`${styles.game_block} d-fl fd-c`}>
      <div className={`${styles.title_container} d-fl ai-c jc-c`}>
        <p className={`${styles.title} d-fl`}>
          <Trans components={{}} transKeepBasicHtmlNodesFor>
            homepage.c2.games.title
          </Trans>
        </p>
      </div>
      <Background />
      <Link className={`${styles.button_container} d-fl ai-c jc-c`} href={PATHS.GAMES}>
        <div className={`${styles.game_button} d-fl ai-c`}>
          <p>{t('homepage.c2.games.button')}</p>
        </div>
      </Link>
    </div>
  );
};
export default GameBlock;
